import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../api';  // Ensure this path matches your API utility file

export const fetchArrears = createAsyncThunk("tds/fetchArrears", async (searchText) => {
  const response = await api.post("/arrears",{ search: searchText });
  return response.data.data;
});

export const addArrears = createAsyncThunk(
  "tds/addArrears",
  async (tdsData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/add-user", tdsData);
      dispatch(fetchArrears());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to save user");
    }
  }
);

export const deleteArrears = createAsyncThunk(
  "tds/deleteArrears",
  async (tdsId, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post(`/delete-tds/${tdsId}`);
      dispatch(fetchArrears());
      return response.data.message;  // Success message from backend
    } catch (error) {
      return rejectWithValue(error.response?.data.message || "Failed to delete user");
    }
  }
);

// Define the initial state and slice
const arrearsSlice = createSlice({
  name: "arrearsData",
  initialState: {
    data: [],
    loading: false,
    isModalOpen: false,
    selectedUserId: null,
    addLoading: false,
    deleteLoading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    openArrearsModal: (state, action) => {
      state.isModalOpen = true;
      state.selectedUserId = action.payload || null;
    },
    closeArrearsModal: (state) => {
      state.isModalOpen = false;
      state.selectedUserId = null;
      state.error = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArrears.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchArrears.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(fetchArrears.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(addArrears.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(addArrears.fulfilled, (state, action) => {
        state.addLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(addArrears.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteArrears.pending, (state) => {
        state.deleteLoading = true;
      })
      .addCase(deleteArrears.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.successMessage = action.payload;
      })
      .addCase(deleteArrears.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
      });
  },
});

export const { openArrearsModal, closeArrearsModal, clearError } = arrearsSlice.actions;
export default arrearsSlice.reducer;
export { arrearsSlice };